import React from 'react';
import $ from 'jquery';
import Projects from './Projects';
const contact=()=>{
     function submit() {
      if(document.getElementById('idname').value.length<=2)
      alert("Sorry!! Your name must have atleast 3 characters")
      else
    alert("Data saved");
    document.getElementById('idname').value="";
    document.getElementById('idemail').value="";
  }
  function call() {
    //   let y=document.querySelector('.whole');
    if (document.querySelector('#load').style.display == "none") {
      $('html').css('overflow-y', 'auto');
      // console.log('nio');
    }
  }
  const LightTheme=()=>{
    // console.log("Neon");
    console.log(document.querySelector('#neon p').innerHTML);
    if(document.querySelector('#neon p').innerHTML==="Light")
    {
    //Intro
    document.querySelector('#neon p').innerHTML="Dark";
    let first=document.getElementById('first');
    first.style.background="rgb(245 238 238)";
    first.style.color="#080808";
    let name1=document.getElementById('name1');
    name1.style.webkitTextStroke="2px #51599d";
    let hospan=document.querySelectorAll('.hover-this span');
    for(let i=0;i<hospan.length;i++)
    hospan[i].style.color="black";
    // let ula=document.querySelector('#nabar ');
    // ula.style.background="#d9dbea";
    // let ula=document.querySelector('.show');
    // ula.style.background="#d9dbea";
    let link=document.querySelectorAll('.link');
    for(let i=0;i<link.length;i++)
    {
    link[i].style.color="rgb(255 1 234)";
    
    }
    // let li=document.querySelectorAll('nav ul li');
    // for(let i=0;i<li.length;i++)
    // {
    //   $(li[i]).hover(function(){
    //     $(this).css("background", "yellow");
    //     // $(this).css("width", "79px");
    //     // $(this).css("border-radius", "30px");
    //   }
    //     , function(){
    //     $(this).css("background", "transparent");
    //   }
    //   );
    // }
    let bold=document.querySelectorAll('.bold');
    for(let i=0;i<bold.length;i++)
    bold[i].style.color="#296329";
    let logo=document.querySelectorAll('.fa');
    for(let i=0;i<2;i++)
    logo[i].style.color="#221679";
    let logolinkedin=document.querySelector('.fa-linkedin');
    $(logolinkedin).hover(function(){
          $(this).css("color", "white");
          // $(this).css("width", "79px");
          // $(this).css("border-radius", "30px");
        }
          , function(){
          $(this).css("color", "#221679");
        }
        );
        let logogit=document.querySelector('.fa-github');
    $(logogit).hover(function(){
          $(this).css("color", "white");
          // $(this).css("width", "79px");
          // $(this).css("border-radius", "30px");
        }
          , function(){
          $(this).css("color", "#221679");
        }
        );
    // let svg=document.querySelector('svg');
    // svg.style.boxShadow="8px 8px 14px grey";
    let btn_line=document.querySelectorAll('.btn-line');
    for(let i=0;i<btn_line.length;i++)
    {
      btn_line[i].style.background="black";
    }

    // About
    let about2=document.getElementById('about2');
    about2.style.color="#074356";
    let second=document.getElementById('second');
    second.style.background="rgb(245 238 238)";
    let para=document.getElementById('para');
    para.style.background="#e4e7ef";
    for(let i=2;i<4;i++)
    logo[i].style.color="black";
    let ski=document.getElementById('ski');
    ski.style="color: #104a28 !important";
    ski.style.fontWeight="bold";
    let langpp=document.querySelectorAll('.langpp');
    // langpp[0].style="color: black !important";
    for(let i=0;i<langpp.length;i++){
    langpp[i].style="color: black !important";
    langpp[i].style.fontWeight="bold";
    }

    // Projects
    let projects=document.querySelector('.projects');
    projects.style.background="rgb(245 238 238)";
    projects.style.color="#0b4a5f";
    let background=document.querySelectorAll('.background');
    for(let i=0;i<background.length;i++)
    background[i].style.background="#d6d5e0";
    let colop=document.querySelectorAll('.col-lg .op');
    for(let i=0;i<colop.length;i++)
    {
      colop[i].style.color="#a52626";
      colop[i].style.fontWeight="bold";
    }
    
    //Contact
    let contact_me=document.getElementById('contact_me');
    contact_me.style.background="rgb(245 238 238)";
    contact_me.style.color="#4a061f";
    let input=document.querySelectorAll('input');
    for(let i=0;i<input.length;i++)
    {
    input[i].style.background="transparent";
    input[i].style.color="black";
    }
    let neonspan=document.querySelectorAll('#neon span');
    for(let i=0;i<neonspan.length;i++)
    neonspan[i].style.background="linear-gradient(90deg, transparent,red)";
    let textarea=document.querySelector('textarea');
    textarea.style.background="#d5dece";
    textarea.style.color="black";
  }
  else{
         //Intro
    document.querySelector('#neon p').innerHTML="Light";
    let first=document.getElementById('first');
    first.style.background="rgb(2, 11, 31)";
    first.style.color="white";
    let hospan=document.querySelectorAll('.hover-this span');
    for(let i=0;i<hospan.length;i++)
    hospan[i].style.color="white";
    let name1=document.getElementById('name1');
    name1.style.webkitTextStroke="2px #77fc77";
    let link=document.querySelectorAll('.link');
    for(let i=0;i<link.length;i++)
    link[i].style.color="lightblue";
    // let li=document.querySelectorAll('nav ul li');
    // for(let i=0;i<li.length;i++)
    // {
    //   $(li[i]).hover(function(){
    //     $(this).css("background", "brown");
    //     // $(this).css("width", "79px");
    //     // $(this).css("border-radius", "30px");
    //   }
    //     , function(){
    //     $(this).css("background", "transparent");
    //   }
    //   );
    // }
    let bold=document.querySelectorAll('.bold');
    for(let i=0;i<bold.length;i++)
    bold[i].style.color="lightgreen";
    let logo=document.querySelectorAll('.fa');
    for(let i=0;i<2;i++)
    logo[i].style.color="white";
    let logolinkedin=document.querySelector('.fa-linkedin');
    $(logolinkedin).hover(function(){
          $(this).css("color", "white");
          // $(this).css("width", "79px");
          // $(this).css("border-radius", "30px");
        }
          , function(){
          $(this).css("color", "yellow");
        }
        );
        let logogit=document.querySelector('.fa-github');
    $(logogit).hover(function(){
          $(this).css("color", "white");
          // $(this).css("width", "79px");
          // $(this).css("border-radius", "30px");
        }
          , function(){
          $(this).css("color", "yellow");
        }
        );
    let svg=document.querySelector('svg');
    svg.style.boxShadow="0px 0px 0px grey";
    let btn_line=document.querySelectorAll('.btn-line');
    for(let i=0;i<btn_line.length;i++)
    {
      btn_line[i].style.background="white";
    }

    // About
    let about2=document.getElementById('about2');
    about2.style.color="lightblue";
    let second=document.getElementById('second');
    second.style.background="rgb(2, 11, 31)";
    let para=document.getElementById('para');
    para.style.background="#8e8f92";
    for(let i=2;i<4;i++)
    logo[i].style.color="white";
    let ski=document.getElementById('ski');
    ski.style="color: #9df4c2 !important";
    ski.style.fontWeight="initial";
    let langpp=document.querySelectorAll('.langpp');
    // langpp[0].style="color: black !important";
    for(let i=0;i<langpp.length;i++){
    langpp[i].style="color: white !important";
    langpp[i].style.fontWeight="bold";
    }

    // Projects
    let projects=document.querySelector('.projects');
    projects.style.background="rgb(2, 11, 31)";
    projects.style.color="#beefff";
    let background=document.querySelectorAll('.background');
    for(let i=0;i<background.length;i++)
    background[i].style.background="#070328";
    let colop=document.querySelectorAll('.col-lg .op');
    for(let i=0;i<colop.length;i++)
    {
      colop[i].style.color="lightblue";
      colop[i].style.fontWeight="initial";
    }

    //Contact
    let contact_me=document.getElementById('contact_me');
    contact_me.style.background="rgb(2, 11, 31)";
    contact_me.style.color="#beefff";
    let input=document.querySelectorAll('input');
    for(let i=0;i<input.length;i++)
    {
    input[i].style.background="transparent";
    input[i].style.color="white";
    }
    let neonspan=document.querySelectorAll('#neon span');
    for(let i=0;i<neonspan.length;i++)
    neonspan[i].style.background="linear-gradient(90deg, transparent,#2196f3)";
    let textarea=document.querySelector('textarea');
    textarea.style.background="#260c24";
    textarea.style.color="white";

  }
  }
    return (
        <>
        <div className="contact" id="contact_me"  onMouseEnter={() => call()}>
                <div id="contact" data-aos="fade-up"
      data-aos-offset="120">
                  C
      <div className="stage" data-aos="zoom-in" data-aos-offset="300">
                    <figure className="ball">
                      <span className="shadow"></span>
                      <span className="iris"></span>
                    </figure>
                  </div>
      ntact
      </div>
                <form action="#contact_me" onSubmit={submit}>
                  <div>
                    <label htmlFor="name" data-aos="fade-right">Name:</label>
                    <input type="name" data-aos="zoom-in"  id="idname" placeholder="Enter your name" required/>
                  </div>
                  <div>
                    <label htmlFor="email" data-aos="fade-right">Email:</label>
                    <input type="email" data-aos="zoom-in" id="idemail" placeholder="Enter your email" required/>
                  </div>
                  <div id="subject">
                    <label for="subject" data-aos="fade-down-right">Message:- </label>
                    <textarea id="subjects" name="subject" placeholder="Write something.." style={{ height: "200px" }}></textarea>
                  </div>

                  <button>Send</button>
                </form>
                <div style={{display: "flex"}}>
                <div onClick={LightTheme}>
                <a  id="neon" >
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <p>Light</p>
                </a>
                </div>
                <div id="uparrow">
                  <button id="arrbtn"><a href="#first" className="link hover-this"><i class="fa fa-arrow-up" aria-hidden="true"/></a></button>
                </div>
                </div>
              </div>
        </>
    );
}
export default contact;